export interface BaseQueryParams {
  limit?: number
  sortDirection?: TypeSortDirection
  cursor?: string
  prev?: string
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export type TypeSortDirection = 'asc' | 'desc' | null
